import { useCallback } from 'react';
import { coreDialogApi } from '@cp/entities/dialog';

export const useCreateDialogByCatalogItem = () => {
  const [trigger] = coreDialogApi.endpoints.createDialog.useMutation();
  return useCallback((catalogItemId: number) => trigger({ catalogItemId }), [trigger]);
};
